import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const FileViewComponent = ({ open, setOpen, vaccination_file }) => {
  const cancelButtonRef = useRef(null);

  const files = Array.isArray(vaccination_file)
    ? vaccination_file
    : vaccination_file
    ? [vaccination_file]
    : [];

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-3xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle p-6">
                <div className="flex items-center justify-between border-b pb-2">
                  <p className="text-sm font-medium">View Uploaded Documents</p>
                  <XMarkIcon className="h-4 w-4 font-bold cursor-pointer" onClick={() => setOpen(false)} />
                </div>

                {files.length > 0 ? (
                  <div className="w-full h-full flex flex-col gap-6 items-center mt-4">
                    {files.map((file, index) => {
                      const isPdf = file.toLowerCase().endsWith(".pdf");

                      return (
                        <div key={index} className="w-full flex flex-col items-center">
                          {isPdf ? (
                            <iframe
                              src={file}
                              title={`Vaccination PDF ${index + 1}`}
                              className="w-full h-[550px] border rounded-lg"
                            />
                          ) : (
                            <TransformWrapper
                              initialScale={1}
                              minScale={0.5}
                              maxScale={3}
                              wheel={{ step: 0.1 }}
                              doubleClick={{ disabled: true }}
                            >
                              {({ zoomIn, zoomOut, resetTransform }) => (
                                <div className="relative w-[650px] h-auto border rounded-lg overflow-hidden mt-2 cursor-pointer">
                                  <TransformComponent>
                                    <img
                                      src={file}
                                      alt={`Vaccination Image ${index + 1}`}
                                      className="object-contain max-h-[600px]"
                                      onClick={() => window.open(file, "_blank")}
                                    />
                                  </TransformComponent>

                                  <div
                                    className="absolute bottom-3 right-2 flex gap-2 rounded p-1"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <button
                                      onClick={() => zoomIn(0.2)}
                                      className="px-3 bg-gray-100 hover:bg-gray-300 rounded text-xl"
                                    >
                                      +
                                    </button>
                                    <button
                                      onClick={() => zoomOut()}
                                      className="px-3 bg-gray-100 hover:bg-gray-300 rounded text-xl"
                                    >
                                      −
                                    </button>
                                    <button
                                      onClick={() => resetTransform()}
                                      className="px-2 py-1 bg-gray-100 hover:bg-gray-200 rounded text-xs"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              )}
                            </TransformWrapper>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="h-[400px] flex justify-center items-center">
                    <p>No Files Available.</p>
                  </div>
                )}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default FileViewComponent;
